import { checkShouldUseMocks } from '@telialt/utils/src/envUtils';

export const LEAD_NAME_PATTERN = /^[a-zA-ZąčęėįšųūžĄČĘĖĮŠŲŪŽ-]+(?: [a-zA-ZąčęėįšųūžĄČĘĖĮŠŲŪŽ-]+)+$/;
export const LEAD_NAME_MIN_LENGTH = 5;
export const LEAD_PHONE_MOBILE_PATTERN = /^(0|\+370)6\d{7}$/;
export const LEAD_PHONE_PREFIX = '+370';
export const LEAD_DEFAULT_SERVICE_TYPE = 'fixed';
export let LEAD_MODAL_BANNER_IMAGE = '/_ui/global/images/gaukite-telia-pasiulyma.png';

export const INPUT_NAMES = {
    NAME: 'p_common_name',
    COMPANY_CODE: 'p_b2b_code',
    PHONE_NUMBER: 'p_telephone_number',
    CONFIRMATION_CODE: 'p_confirmation_code',
    COMMENT: 'p_comment',
};

export const API = {
    URL_LEAD_SUBMIT: '/ajax/leads/{segment}',
    URL_LEAD_SMS_CONFIRM: '/ajax/leads/sms',
};

if (checkShouldUseMocks({ shouldUseInTest: true })) {
    LEAD_MODAL_BANNER_IMAGE = '/images/gaukite-telia-pasiulyma.png';

    API.URL_LEAD_SUBMIT = '/api/leads/{segment}';
    API.URL_LEAD_SMS_CONFIRM = '/api/leads/sms';
}
